module.exports = __webpack_public_path__ + "img/goal-fourteen-br.fa9093e9.png";